import React from "react";
import { Outlet } from "react-router-dom";
import Common from "../layout/Common";

// Define the type for props
interface PublicRouteProps {
  children?: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = () => {
  // PublicRoute now allows both authenticated and guest users
  // The route protection is handled by PrivateRoute for authenticated-only routes
  return <Common><Outlet/></Common>;
};

export default PublicRoute;
